import React from 'react';
import { Linking, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { theme } from '../theme/theme';

const openPolicy = (url) => {
    Linking.openURL(url).catch(() => {});
};

const RecaptchaNotice = ({ visible = false }) => {
    if (!visible) { return null; }
    return (
        <Text style={styles.notice}>
            This site is protected by reCAPTCHA and the Google{' '}
            <Text accessibilityRole="link" style={styles.link} onPress={() => openPolicy('https://policies.google.com/privacy')}>
                Privacy Policy
            </Text>{' '}
            and{' '}
            <Text accessibilityRole="link" style={styles.link} onPress={() => openPolicy('https://policies.google.com/terms')}>
                Terms of Service
            </Text>{' '}
            apply.
        </Text>
    );
};

const styles = StyleSheet.create({
    notice: {
        marginTop: 16,
        paddingHorizontal: 8,
        textAlign: 'center',
        color: '#64748b',
        fontSize: 11,
        lineHeight: 16,
    },
    link: {
        color: theme.colors.primary,
        textDecorationLine: 'underline',
    },
});

export default RecaptchaNotice;

